import { render, staticRenderFns } from "./categ_node.vue?vue&type=template&id=3bb2d7e8&scoped=true&"
import script from "./categ_node.vue?vue&type=script&lang=js&"
export * from "./categ_node.vue?vue&type=script&lang=js&"
import style0 from "./categ_node.vue?vue&type=style&index=0&id=3bb2d7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2d7e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb2d7e8')) {
      api.createRecord('3bb2d7e8', component.options)
    } else {
      api.reload('3bb2d7e8', component.options)
    }
    module.hot.accept("./categ_node.vue?vue&type=template&id=3bb2d7e8&scoped=true&", function () {
      api.rerender('3bb2d7e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/sub/categ_node.vue"
export default component.exports